import React, { useState, useEffect, useContext, useRef } from "react";
import "../../../../constants/report.css";
import axios from "axios";
import { AuthContext } from "../../../../contexts/AuthContext";
import { tempUrl, useStateContext } from "../../../../contexts/ContextProvider";
import { Loader } from "../../../../components";
import { formatDate } from "../../../../constants/helper";
import {
  Box,
  ButtonGroup,
  Button,
  Autocomplete,
  TextField,
} from "@mui/material";
import { Container, Form, Row, Col, Table } from "react-bootstrap";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import jsPDF from "jspdf";
import { useDownloadExcel } from "react-export-table-to-excel";
import SearchIcon from "@mui/icons-material/Search";
import PrintIcon from "@mui/icons-material/Print";
import { useReactToPrint } from "react-to-print";
import useScreenWidth from "../../../../hooks/useScreenWidth";

const LaporanPenjualanPerHari = () => {
  const screenSize = useScreenWidth();
  const tableRef = useRef(null);
  const { user, dispatch, setting } = useContext(AuthContext);
  const reportTemplateRef = useRef(null);
  let nowDate = new Date();
  let [sampaiTanggal, setSampaiTanggal] = useState(
    new Date(user.tutupperiode.sampaiTanggal)
  );
  let [dariTanggal, setDariTanggal] = useState(
    new Date(user.tutupperiode.dariTanggal)
  );
  const [kodeCabang, setKodeCabang] = useState("");
  const [namaCabang, setNamaCabang] = useState("");

  const [cabangs, setCabangs] = useState([]);
  const [loading, setLoading] = useState(false);
  const [persenLoading, setPersenLoading] = useState("0");
  const [lapPenjualanPerHaris, setLapPenjualanPerHaris] = useState([]);
  const [previewPdf, setPreviewPdf] = useState(false);
  const [isCetakExcel, setIsCetakExcel] = useState(false);
  const [error, setError] = useState(false);

  let cabangOptions = cabangs.map((cabang) => ({
    label: `${cabang.id} - ${cabang.namaCabang}`,
    id: `${cabang.id} - ${cabang.namaCabang}`,
  }));

  const generatePDF = useReactToPrint({
    content: () => reportTemplateRef.current,
    documentTitle: "LaporanPenjualanPerHari",
  });

  const tampilPdf = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    const form = e.currentTarget;
    if (form.checkValidity()) {
      setLoading(true);
      let tempPersenLoading = parseInt(persenLoading);

      setTimeout(() => {
        tempPersenLoading += 40;
        setPersenLoading(tempPersenLoading.toString());
      }, "1000");

      let laporanPenjualanPerHari = await axios.post(
        `${tempUrl}/laporanPenjualanPerHari`,
        {
          dariTanggal,
          sampaiTanggal,
          kodeCabang,
          _id: user.id,
          token: user.token,
        }
      );
      setLapPenjualanPerHaris(laporanPenjualanPerHari.data);
      setPreviewPdf(!previewPdf);
      setLoading(false);
      setTimeout(() => {
        tempPersenLoading = 0;
        setPersenLoading(tempPersenLoading.toString());
      }, "2000");
    }
  };

  useEffect(() => {
    getCabangsData();
    if (user.tipeUser !== "OWNER/DIREKSI") {
      setKodeCabang(user.cabang.id);
      setNamaCabang(`${user.cabang.id} - ${user.cabang.namaCabang}`);
    }
  }, []);

  const getCabangsData = async () => {
    const response = await axios.post(`${tempUrl}/cabangs`, {
      _id: user.id,
      token: user.token,
      kodeCabang: user.cabang.id,
    });
    setCabangs(response.data);
  };

  const tableText = {
    letterSpacing: "0.01px",
  };

  const textBold = {
    fontWeight: 700,
    border: "1px solid black",
  };

  const textRight = {
    textAlign: screenSize >= 650 && "right",
  };

  const textNumberRight = {
    textAlign: "right",
    border: "1px solid black",
  };

  const textNumberRightBold = {
    textAlign: "right",
    fontWeight: 700,
    border: "1px solid black",
  };

  const list = [];

  let tempTotalJenisStokJasaShift1 = 0;
  let tempTotalJenisStokOliShift1 = 0;
  let tempTotalJenisStokSparepartShift1 = 0;
  let tempTotalTotalShift1 = 0;
  let tempTotalNotaShift1 = 0;

  let tempTotalJenisStokJasaShift2 = 0;
  let tempTotalJenisStokOliShift2 = 0;
  let tempTotalJenisStokSparepartShift2 = 0;
  let tempTotalTotalShift2 = 0;
  let tempTotalNotaShift2 = 0;

  let tempTotalTotalJenisStokJasa = 0;
  let tempTotalTotalJenisStokOli = 0;
  let tempTotalTotalJenisStokSparepart = 0;
  let tempTotalTotalShift = 0;
  let tempTotalTotalNota = 0;

  for (let j = 0; j < lapPenjualanPerHaris.length; j++) {
    tempTotalJenisStokJasaShift1 += lapPenjualanPerHaris[j].jenisStokJasaShift1;
    tempTotalJenisStokOliShift1 += lapPenjualanPerHaris[j].jenisStokOliShift1;
    tempTotalJenisStokSparepartShift1 +=
      lapPenjualanPerHaris[j].jenisStokSparepartShift1;
    tempTotalTotalShift1 += lapPenjualanPerHaris[j].totalShift1;
    tempTotalNotaShift1 += lapPenjualanPerHaris[j].notaShift1;

    tempTotalJenisStokJasaShift2 += lapPenjualanPerHaris[j].jenisStokJasaShift2;
    tempTotalJenisStokOliShift2 += lapPenjualanPerHaris[j].jenisStokOliShift2;
    tempTotalJenisStokSparepartShift2 +=
      lapPenjualanPerHaris[j].jenisStokSparepartShift2;
    tempTotalTotalShift2 += lapPenjualanPerHaris[j].totalShift2;
    tempTotalNotaShift2 += lapPenjualanPerHaris[j].notaShift2;

    tempTotalTotalJenisStokJasa += lapPenjualanPerHaris[j].totalJenisStokJasa;
    tempTotalTotalJenisStokOli += lapPenjualanPerHaris[j].totalJenisStokOli;
    tempTotalTotalJenisStokSparepart +=
      lapPenjualanPerHaris[j].totalJenisStokSparepart;
    tempTotalTotalShift += lapPenjualanPerHaris[j].totalShift;
    tempTotalTotalNota += lapPenjualanPerHaris[j].totalNota;

    list.push(
      <tr style={tableText}>
        <td style={{ paddingLeft: "15px", border: "1px solid black" }}>
          {formatDate(lapPenjualanPerHaris[j].tanggal)}
        </td>
        <td style={textNumberRight}>
          {isCetakExcel === false
            ? lapPenjualanPerHaris[j].jenisStokJasaShift1.toLocaleString(
                "en-EN"
              )
            : lapPenjualanPerHaris[j].jenisStokJasaShift1}
        </td>
        <td style={textNumberRight}>
          {isCetakExcel === false
            ? lapPenjualanPerHaris[j].jenisStokOliShift1.toLocaleString("en-EN")
            : lapPenjualanPerHaris[j].jenisStokOliShift1}
        </td>
        <td style={textNumberRight}>
          {isCetakExcel === false
            ? lapPenjualanPerHaris[j].jenisStokSparepartShift1.toLocaleString(
                "en-EN"
              )
            : lapPenjualanPerHaris[j].jenisStokSparepartShift1}
        </td>
        <td style={textNumberRight}>
          {isCetakExcel === false
            ? lapPenjualanPerHaris[j].totalShift1.toLocaleString("en-EN")
            : lapPenjualanPerHaris[j].totalShift1}
        </td>
        <td style={textNumberRight}>
          {isCetakExcel === false
            ? lapPenjualanPerHaris[j].notaShift1.toLocaleString("en-EN")
            : lapPenjualanPerHaris[j].notaShift1}
        </td>

        <td style={textNumberRight}>
          {isCetakExcel === false
            ? lapPenjualanPerHaris[j].jenisStokJasaShift2.toLocaleString(
                "en-EN"
              )
            : lapPenjualanPerHaris[j].jenisStokJasaShift2}
        </td>
        <td style={textNumberRight}>
          {isCetakExcel === false
            ? lapPenjualanPerHaris[j].jenisStokOliShift2.toLocaleString("en-EN")
            : lapPenjualanPerHaris[j].jenisStokOliShift2}
        </td>
        <td style={textNumberRight}>
          {isCetakExcel === false
            ? lapPenjualanPerHaris[j].jenisStokSparepartShift2.toLocaleString(
                "en-EN"
              )
            : lapPenjualanPerHaris[j].jenisStokSparepartShift2}
        </td>
        <td style={textNumberRight}>
          {isCetakExcel === false
            ? lapPenjualanPerHaris[j].totalShift2.toLocaleString("en-EN")
            : lapPenjualanPerHaris[j].totalShift2}
        </td>
        <td style={textNumberRight}>
          {isCetakExcel === false
            ? lapPenjualanPerHaris[j].notaShift2.toLocaleString("en-EN")
            : lapPenjualanPerHaris[j].notaShift2}
        </td>

        <td style={textNumberRight}>
          {isCetakExcel === false
            ? lapPenjualanPerHaris[j].totalJenisStokJasa.toLocaleString("en-EN")
            : lapPenjualanPerHaris[j].totalJenisStokJasa}
        </td>
        <td style={textNumberRight}>
          {isCetakExcel === false
            ? lapPenjualanPerHaris[j].totalJenisStokOli.toLocaleString("en-EN")
            : lapPenjualanPerHaris[j].totalJenisStokOli}
        </td>
        <td style={textNumberRight}>
          {isCetakExcel === false
            ? lapPenjualanPerHaris[j].totalJenisStokSparepart.toLocaleString(
                "en-EN"
              )
            : lapPenjualanPerHaris[j].totalJenisStokSparepart}
        </td>
        <td style={textNumberRight}>
          {isCetakExcel === false
            ? lapPenjualanPerHaris[j].totalShift.toLocaleString("en-EN")
            : lapPenjualanPerHaris[j].totalShift}
        </td>
        <td style={textNumberRight}>
          {isCetakExcel === false
            ? lapPenjualanPerHaris[j].totalNota.toLocaleString("en-EN")
            : lapPenjualanPerHaris[j].totalNota}
        </td>
      </tr>
    );
  }

  list.push(
    <tr style={tableText}>
      <td style={textBold}>TOTAL :</td>
      <td style={textNumberRightBold}>
        {isCetakExcel === false
          ? tempTotalJenisStokJasaShift1.toLocaleString("en-EN")
          : tempTotalJenisStokJasaShift1}
      </td>
      <td style={textNumberRightBold}>
        {isCetakExcel === false
          ? tempTotalJenisStokOliShift1.toLocaleString("en-EN")
          : tempTotalJenisStokOliShift1}
      </td>
      <td style={textNumberRightBold}>
        {isCetakExcel === false
          ? tempTotalJenisStokSparepartShift1.toLocaleString("en-EN")
          : tempTotalJenisStokSparepartShift1}
      </td>
      <td style={textNumberRightBold}>
        {isCetakExcel === false
          ? tempTotalTotalShift1.toLocaleString("en-EN")
          : tempTotalTotalShift1}
      </td>
      <td style={textNumberRightBold}>
        {isCetakExcel === false
          ? tempTotalNotaShift1.toLocaleString("en-EN")
          : tempTotalNotaShift1}
      </td>

      <td style={textNumberRightBold}>
        {isCetakExcel === false
          ? tempTotalJenisStokJasaShift2.toLocaleString("en-EN")
          : tempTotalJenisStokJasaShift2}
      </td>
      <td style={textNumberRightBold}>
        {isCetakExcel === false
          ? tempTotalJenisStokOliShift2.toLocaleString("en-EN")
          : tempTotalJenisStokOliShift2}
      </td>
      <td style={textNumberRightBold}>
        {isCetakExcel === false
          ? tempTotalJenisStokSparepartShift2.toLocaleString("en-EN")
          : tempTotalJenisStokSparepartShift2}
      </td>
      <td style={textNumberRightBold}>
        {isCetakExcel === false
          ? tempTotalTotalShift2.toLocaleString("en-EN")
          : tempTotalTotalShift2}
      </td>
      <td style={textNumberRightBold}>
        {isCetakExcel === false
          ? tempTotalNotaShift2.toLocaleString("en-EN")
          : tempTotalNotaShift2}
      </td>

      <td style={textNumberRightBold}>
        {isCetakExcel === false
          ? tempTotalTotalJenisStokJasa.toLocaleString("en-EN")
          : tempTotalTotalJenisStokJasa}
      </td>
      <td style={textNumberRightBold}>
        {isCetakExcel === false
          ? tempTotalTotalJenisStokOli.toLocaleString("en-EN")
          : tempTotalTotalJenisStokOli}
      </td>
      <td style={textNumberRightBold}>
        {isCetakExcel === false
          ? tempTotalTotalJenisStokSparepart.toLocaleString("en-EN")
          : tempTotalTotalJenisStokSparepart}
      </td>
      <td style={textNumberRightBold}>
        {isCetakExcel === false
          ? tempTotalTotalShift.toLocaleString("en-EN")
          : tempTotalTotalShift}
      </td>
      <td style={textNumberRightBold}>
        {isCetakExcel === false
          ? tempTotalTotalNota.toLocaleString("en-EN")
          : tempTotalTotalNota}
      </td>
    </tr>
  );

  const { onDownload } = useDownloadExcel({
    currentTableRef: tableRef.current,
    filename: "LaporanPenjualanPerHari",
    sheet: "LaporanPenjualanPerHari",
  });

  if (loading) {
    return <Loader persenLoading={persenLoading} />;
  }

  return (
    <Container>
      <h3>Laporan</h3>
      <h5 style={{ fontWeight: 400 }}>Laporan Penjualan Per Hari</h5>
      <hr />
      <Box sx={spacingTop}>
        <Form onSubmit={tampilPdf}>
          <Row>
            <Col sm={6}>
              <Form.Group
                as={Row}
                className="mb-3"
                controlId="formPlaintextPassword"
              >
                <Form.Label column sm="4" style={textRight}>
                  Cabang :
                </Form.Label>
                <Col sm="8">
                  {user.tipeUser === "OWNER/DIREKSI" ? (
                    <Autocomplete
                      size="small"
                      disablePortal
                      id="combo-box-demo"
                      options={cabangOptions}
                      renderInput={(params) => (
                        <TextField
                          error={error && kodeCabang.length === 0 && true}
                          size="small"
                          placeholder="SEMUA CABANG"
                          {...params}
                        />
                      )}
                      onChange={(e, value) => {
                        if (value) {
                          setKodeCabang(value.id.split(" ", 1)[0]);
                          setNamaCabang(value.id);
                        } else {
                          setKodeCabang("");
                          setNamaCabang("");
                        }
                        setPreviewPdf(false);
                      }}
                      defaultValue={kodeCabang}
                    />
                  ) : (
                    <Form.Control value={kodeCabang} disabled readOnly />
                  )}
                </Col>
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col sm={6}>
              <Form.Group
                as={Row}
                className="mb-3"
                controlId="formPlaintextPassword"
              >
                <Form.Label column sm="4" style={textRight}>
                  Dari :
                </Form.Label>
                <Col sm="8">
                  <DatePicker
                    required
                    dateFormat="dd/MM/yyyy"
                    selected={dariTanggal}
                    customInput={<Form.Control required />}
                    onChange={(date) => {
                      setDariTanggal(date);
                      setPreviewPdf(false);
                    }}
                  />
                </Col>
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col sm={6}>
              <Form.Group
                as={Row}
                className="mb-3"
                controlId="formPlaintextPassword"
              >
                <Form.Label column sm="4" style={textRight}>
                  Sampai :
                </Form.Label>
                <Col sm="8">
                  <DatePicker
                    required
                    dateFormat="dd/MM/yyyy"
                    selected={sampaiTanggal}
                    customInput={<Form.Control required />}
                    onChange={(date) => {
                      setSampaiTanggal(date);
                      setPreviewPdf(false);
                    }}
                  />
                </Col>
              </Form.Group>
            </Col>
          </Row>
          <Button
            variant="contained"
            startIcon={<SearchIcon />}
            type="submit"
            style={{ marginTop: "20px" }}
          >
            LIHAT
          </Button>
        </Form>
      </Box>

      {previewPdf && (
        <div style={{ marginTop: "10px" }}>
          <ButtonGroup variant="outlined" color="secondary">
            <Button startIcon={<PrintIcon />} onClick={generatePDF}>
              PDF
            </Button>
            <Button
              startIcon={<SearchIcon />}
              onClick={() => {
                setIsCetakExcel(true);
                setTimeout(() => {
                  onDownload();
                }, "1000");
              }}
            >
              Excel
            </Button>
          </ButtonGroup>
        </div>
      )}
      <div ref={reportTemplateRef} id="content" style={pdfContainer}>
        <div style={{ visibility: previewPdf === true ? "visible" : "hidden" }}>
          <p>
            {setting.namaPerusahaan} - {setting.alamatPerusahaan}
          </p>
          <p>({setting.kabupatenPerusahaan})</p>
          <p>{setting.kotaPerusahaan}</p>
          <p>NO. TELP. {setting.teleponPerusahaan}</p>
          <p>
            Dicetak Oleh: {user.username} | Tanggal:
            {` ${nowDate.getDate().toLocaleString("en-US", {
              minimumIntegerDigits: 2,
              useGrouping: false,
            })}/${(nowDate.getMonth() + 1).toLocaleString("en-US", {
              minimumIntegerDigits: 2,
              useGrouping: false,
            })}/${nowDate.getFullYear()} `}{" "}
            | Jam:{" "}
            {` ${nowDate.getHours().toLocaleString("en-US", {
              minimumIntegerDigits: 2,
              useGrouping: false,
            })}:${(nowDate.getMinutes() + 1).toLocaleString("en-US", {
              minimumIntegerDigits: 2,
              useGrouping: false,
            })}:${nowDate.getSeconds().toLocaleString("en-US", {
              minimumIntegerDigits: 2,
              useGrouping: false,
            })} `}
          </p>
          <h5 style={{ textAlign: "center", fontWeight: "700" }}>
            Laporan Penjualan Per Hari
          </h5>
          <p>
            Dari Tanggal :
            {` ${dariTanggal.getDate().toLocaleString("en-US", {
              minimumIntegerDigits: 2,
              useGrouping: false,
            })}/${(dariTanggal.getMonth() + 1).toLocaleString("en-US", {
              minimumIntegerDigits: 2,
              useGrouping: false,
            })}/${dariTanggal.getFullYear()}`}
          </p>
          <p>
            Sampai Tanggal :
            {` ${sampaiTanggal.getDate().toLocaleString("en-US", {
              minimumIntegerDigits: 2,
              useGrouping: false,
            })}/${(sampaiTanggal.getMonth() + 1).toLocaleString("en-US", {
              minimumIntegerDigits: 2,
              useGrouping: false,
            })}/${sampaiTanggal.getFullYear()}`}
          </p>
          <p>Cabang : {namaCabang}</p>
          <p></p>
          <table class="styled-table" ref={tableRef}>
            <thead>
              <tr>
                <th style={{ border: "1px solid black" }} rowSpan={2}>
                  TANGGAL
                </th>
                <th
                  style={{ border: "1px solid black", textAlign: "center" }}
                  colSpan={5}
                >
                  SHIFT 1
                </th>
                <th
                  style={{ border: "1px solid black", textAlign: "center" }}
                  colSpan={5}
                >
                  SHIFT 2
                </th>
                <th
                  style={{ border: "1px solid black", textAlign: "center" }}
                  colSpan={5}
                >
                  TOTAL
                </th>
              </tr>
              <tr>
                <th style={{ border: "1px solid black" }}>JASA</th>
                <th style={{ border: "1px solid black" }}>OLI</th>
                <th style={{ border: "1px solid black" }}>SPAREPART</th>
                <th style={{ border: "1px solid black" }}>TOTAL</th>
                <th style={{ border: "1px solid black" }}>NOTA</th>
                <th style={{ border: "1px solid black" }}>JASA</th>
                <th style={{ border: "1px solid black" }}>OLI</th>
                <th style={{ border: "1px solid black" }}>SPAREPART</th>
                <th style={{ border: "1px solid black" }}>TOTAL</th>
                <th style={{ border: "1px solid black" }}>NOTA</th>
                <th style={{ border: "1px solid black" }}>JASA</th>
                <th style={{ border: "1px solid black" }}>OLI</th>
                <th style={{ border: "1px solid black" }}>SPAREPART</th>
                <th style={{ border: "1px solid black" }}>TOTAL</th>
                <th style={{ border: "1px solid black" }}>NOTA</th>
              </tr>
            </thead>
            <tbody>{list}</tbody>
          </table>
        </div>
      </div>
    </Container>
  );
};

export default LaporanPenjualanPerHari;

const spacingTop = {
  mt: 4,
};

const pdfContainer = {
  padding: "20px",
  letterSpacing: "0.01px",
  fontSize: "10px",
  fontFamily: "sans-serif",
  width: "1000px",
};
